import { Box, Button, CardMedia, Container, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from 'route/RouteEnums';

const MFSHNavigate = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate(`${ROUTE.MFSH_ASSESSMENT}`, { state: { understand: true } });
  };

  return (
    <>
      <Grid item xs={1} display={'flex'} flexDirection={'row-reverse'} sx={{ m: '20px 20px 0 0' }}>
        <Button variant='text' sx={{ color: '#000' }} onClick={() => navigate(`${ROUTE.DASHBOARD}`)}>
          X
        </Button>
      </Grid>
      <Container
        component='section'
        maxWidth='xl'
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} pb={2} maxWidth={'md'}>
          <CardMedia component={'img'} src='/images/mcat1.svg' alt='main_logo' sx={{ width: 82, height: 84 }} />
          <Typography variant='h1' textAlign={'center'} pt={4} pb={4}>
            Medical, Family & Social History
          </Typography>
          <Typography variant='h2' textAlign={'center'} pt={3} pb={2}>
            Understanding your child’s mental & physical health history, development, and daily environment
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: '30px 24px 24px 24px',
              alignItems: 'flex-start',
              borderRadius: '8px',
              background: '#fff',
              boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.12)',
            }}
          >
            <Box sx={{ fontSize: '18px', lineHeight: '28px' }}>
              <Typography textAlign={'left'} sx={{ fontSize: '18px', color: '#2C3446' }}>
                This section helps us better understand your child’s mental health treatment history, medical history,
                development, education, family background, and daily environment.
              </Typography>
            </Box>
            <Box sx={{ fontSize: '18px', lineHeight: '28px', marginTop: '10px' }}>
              <Typography textAlign={'left'} sx={{ fontSize: '18px', color: '#2C3446' }}>
                The information you provide helps our clinical team better understand your child’s needs and create a
                personalized treatment approach.Please answer the questions as accurately as possible.
              </Typography>
            </Box>
            <Box sx={{ fontSize: '18px', lineHeight: '28px', marginTop: '10px' }}>
              <Typography textAlign={'left'} sx={{ fontSize: '18px', color: '#2C3446' }}>
                Thank you for taking the time to complete this important step.
              </Typography>
            </Box>
          </Box>
          <Box mt={4} textAlign={'center'}>
            <Button onClick={handleNavigation}>Let&apos;s Get Started</Button>
          </Box>
        </Box>
        <Grid container sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Grid item sm={4}>
            <CardMedia
              component={'img'}
              src='/images/mcatFooter.png'
              alt='main_logo'
              sx={{ width: 'auto', height: 200 }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MFSHNavigate;
